export default __webpack_public_path__ + "static/media/hearth.ae120be2.svg";